// extracted by mini-css-extract-plugin
export default {"container":"PV5Q11","subtitle":"iiKgIb"};